import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'arrow-alt-circle-up': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCircleUp" */
        '@fortawesome/free-regular-svg-icons/faCircleUp'
    ),
    'bell-slash': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faBellSlash" */
        '@fortawesome/free-regular-svg-icons/faBellSlash'
    ),
    'clock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faClockFour" */
        '@fortawesome/free-regular-svg-icons/faClockFour'
    ),
    'closed-captioning': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faClosedCaptioning" */
        '@fortawesome/free-regular-svg-icons/faClosedCaptioning'
    ),
    'comment': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faComment" */
        '@fortawesome/free-regular-svg-icons/faComment'
    ),
    'file-lines': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFileText" */
        '@fortawesome/free-regular-svg-icons/faFileText'
    ),
    'grin-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinBeam" */
        '@fortawesome/free-regular-svg-icons/faGrinBeam'
    ),
    'hand-rock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHandRock" */
        '@fortawesome/free-regular-svg-icons/faHandRock'
    ),
    'hand-spock': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHandSpock" */
        '@fortawesome/free-regular-svg-icons/faHandSpock'
    ),
    'hourglass-2': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHourglassHalf" */
        '@fortawesome/free-regular-svg-icons/faHourglassHalf'
    ),
    'snowflake': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSnowflake" */
        '@fortawesome/free-regular-svg-icons/faSnowflake'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>